/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import  {
    faTwitter,
    faYoutube,
    faInstagram,
    faFacebookF,
    faLinkedinIn
} from "@awesome.me/kit-db56931b65/icons/classic/brands";

const brands = {
    faTwitter,
    faYoutube,
    faInstagram,
    faFacebookF,
    faLinkedinIn,
};

export {
    brands,
};
